(function () {
  const LOGOUT_FLAG = 'customer_logged_out';

  function getReturnTo(link) {
    const returnTo = link.dataset.returnTo || '/';
    return returnTo.startsWith('/') ? returnTo : '/';
  }

  function redirectAfterLogout(returnTo) {
    sessionStorage.setItem(LOGOUT_FLAG, '1');
    const separator = returnTo.includes('?') ? '&' : '?';
    window.location.replace(`${returnTo}${separator}customer_logout=${Date.now()}`);
  }

  function handleLogoutClick(event) {
    const link = event.target.closest('[data-customer-logout]');
    if (!link) return;

    event.preventDefault();

    const logoutUrl = link.getAttribute('href');
    const returnTo = getReturnTo(link);

    if (!logoutUrl) {
      redirectAfterLogout(returnTo);
      return;
    }

    fetch(logoutUrl, {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      redirect: 'follow',
    }).finally(() => {
      redirectAfterLogout(returnTo);
    });
  }

  function handlePageShow(event) {
    if (event.persisted) {
      window.location.reload();
    }
  }

  function init() {
    document.addEventListener('click', handleLogoutClick);
    window.addEventListener('pageshow', handlePageShow);

    if (sessionStorage.getItem(LOGOUT_FLAG)) {
      sessionStorage.removeItem(LOGOUT_FLAG);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
